import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    list: String
  }

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    const list = document.querySelector(this.listValue)

    if (!list) return

    const items = list.querySelectorAll("[data-filter-item]")

    items.forEach(item => {
      const searchText = item.dataset.searchText || item.textContent.toLowerCase()

      if (query === "" || searchText.includes(query)) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }
}
